export enum UserRole {
  owner = "OWNER",
  ownerViewer = "OWNER VIEWER",
  user = "USER",
}

export interface User {
  id?: string;
  name: string;
  email: string;
  role: UserRole;
  phone: string;
  department?: string | null;
  position?: string | null;
}
